import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f66b7d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" User login:")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "user-caption" }
const _hoisted_11 = { class: "user-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Name", -1))
const _hoisted_13 = { class: "user-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Producer", -1))
const _hoisted_15 = { class: "user-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "GW name", -1))
const _hoisted_17 = { class: "user-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "GW org", -1))
const _hoisted_19 = { class: "user-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status", -1))
const _hoisted_21 = { class: "user-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Password last changed", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "user-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Last login", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { class: "user-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "user-field" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "This User's Groups:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Producer's Finance Admins:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Producer's User Admins:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", null, "(Note: producer admin lists may be up to 24 hrs old.)")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSearchString && _ctx.updateSearchString(...args))),
        ref: "searchInput",
        class: "search-input"
      }, null, 544),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.clearSearch()), ["prevent"])),
        href: "",
        class: "search-clear"
      }, [
        _createElementVNode("img", {
          src: `${_ctx.publicPath}icons/close.svg`,
          alt: "X"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _hoisted_5,
    (_ctx.hasUsersError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " There was an error retrieving users "))
      : _createCommentVNode("", true),
    (_ctx.userSearchString && !_ctx.usersInfo && !_ctx.hasUsersError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.usersInfo && _ctx.usersInfo.length === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " No users found "))
      : _createCommentVNode("", true),
    (_ctx.usersInfo && _ctx.usersInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersInfo, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              key: user.id,
              class: "user-section"
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(user.profile.email), 1),
              _createElementVNode("span", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(": " + _toDisplayString(user.profile.firstName) + " " + _toDisplayString(user.profile.lastName), 1)
              ]),
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(": " + _toDisplayString(user.profile.producerCode), 1)
              ]),
              _createElementVNode("span", _hoisted_15, [
                _hoisted_16,
                _createTextVNode(": " + _toDisplayString(user.profile.gwUserName), 1)
              ]),
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createTextVNode(": " + _toDisplayString(user.profile.gwOrganization), 1)
              ]),
              _createElementVNode("span", _hoisted_19, [
                _hoisted_20,
                _createTextVNode(": " + _toDisplayString(user.status), 1)
              ]),
              _createElementVNode("span", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _createTextVNode(" " + _toDisplayString(_ctx.formatDate(user.passwordChanged)), 1)
              ]),
              _createElementVNode("span", _hoisted_25, [
                _hoisted_26,
                _hoisted_27,
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.getLoginText(user.lastLogin)), 1)
              ]),
              _createElementVNode("span", _hoisted_29, [
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _createTextVNode(" " + _toDisplayString(_ctx.getLoginText(user.created)), 1)
              ]),
              _createElementVNode("span", _hoisted_33, [
                (_ctx.selectedUser !== user.id)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "",
                      onClick: _withModifiers(($event: any) => (_ctx.showUserGroupInfo(user)), ["prevent"]),
                      class: "show-info-link"
                    }, " Show group info ", 8, _hoisted_34))
                  : _createCommentVNode("", true),
                (_ctx.selectedUser === user.id)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.hideUserGroupInfo()), ["prevent"]))
                    }, " Hide group info "))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedUser === user.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (!_ctx.hasGroupsError && _ctx.userGroupInfo === null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Loading..."))
                      : _createCommentVNode("", true),
                    (_ctx.hasGroupsError)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Error loading group info"))
                      : _createCommentVNode("", true),
                    (_ctx.userGroupInfo !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", null, [
                            _hoisted_39,
                            _createTextVNode(" " + _toDisplayString(_ctx.userGroupText), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_40,
                            _createTextVNode(" " + _toDisplayString(_ctx.financeAdminList), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(_ctx.userAdminList), 1)
                          ]),
                          _hoisted_42
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}